'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { BodyDefault } from '../../components/typography';
import { PageHeader } from '../page-header/PageHeader';

export type ListPageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode[];
};

export function ListPageHeader({
  title,
  subtitle,
  actions,
}: ListPageHeaderProps) {
  return (
    <Box px="2" pt="1" pb="2">
      <PageHeader
        title={title}
        subtitle={
          subtitle ? (
            <BodyDefault color="fg.neutral.muted">{subtitle}</BodyDefault>
          ) : undefined
        }
        buttons={actions}
      />
    </Box>
  );
}
